import { CommonModule } from "@angular/common";
import { ComponentFactoryResolver, NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatIconModule } from "@angular/material/icon";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatLegacyCardModule as MatCardModule } from "@angular/material/legacy-card";
import { MatLegacyDialogModule as MatDialogModule } from "@angular/material/legacy-dialog";
import { MatLegacyFormFieldModule as MatFormFieldModule } from "@angular/material/legacy-form-field";
import { MatLegacyInputModule as MatInputModule } from "@angular/material/legacy-input";
import { MatLegacyMenuModule as MatMenuModule } from "@angular/material/legacy-menu";
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from "@angular/material/legacy-progress-spinner";
import { MatLegacySelectModule as MatSelectModule } from "@angular/material/legacy-select";
import { MatLegacyTabsModule as MatTabsModule } from "@angular/material/legacy-tabs";
import { MatLegacyTooltipModule as MatTooltipModule } from "@angular/material/legacy-tooltip";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { DialogLayoutModule } from "@obg/mat.ui.core";
import { AppContextConfigService } from "@obg/ngx.core";
import { DateService, GlobalModule } from "@obg/ngx.global";
import { RouterModule } from "@obg/ngx.router";
import { CommonValidationRendererModule, NumericValidatorDirective } from "@obg/ngx.ui.common";
import { ImageContentDirectiveModule } from "@obg/ngx.ui.core";

import { DepositLimitCalculatorBanner } from "./deposit-limit-calculator-banner/deposit-limit-calculator-banner.component";
import { DepositLimitCalculatorDateService } from "./deposit-limit-calculator-date.service";
import { DepositLimitCalculatorFormComponent } from "./deposit-limit-calculator-form/deposit-limit-calculator-form.component";
import { DepositLimitCalculatorInfoModalComponent } from "./deposit-limit-calculator-info-modal/deposit-limit-calculator-info-modal.component";
import { DepositLimitCalculatorResultComponent } from "./deposit-limit-calculator-result/deposit-limit-calculator-result.component";
import { DepositLimitCalculatorContainer } from "./deposit-limit-calculator.container";

const PROVIDERS = [AppContextConfigService, TranslateService, DepositLimitCalculatorDateService, DateService];

const DIRECTIVES: any[] = [
	DepositLimitCalculatorContainer,
	DepositLimitCalculatorInfoModalComponent,
	DepositLimitCalculatorFormComponent,
	DepositLimitCalculatorResultComponent,
	DepositLimitCalculatorBanner,
	NumericValidatorDirective,
];

const MATERIAL_MODULES = [
	MatTabsModule,
	MatIconModule,
	MatTooltipModule,
	MatExpansionModule,
	MatCardModule,
	MatFormFieldModule,
	MatInputModule,
	MatButtonModule,
	MatProgressSpinnerModule,
	MatDatepickerModule,
	MatMenuModule,
	MatSelectModule,
];

@NgModule({
	imports: [
		CommonModule,
		GlobalModule,
		TranslateModule,
		FormsModule,
		ReactiveFormsModule,
		ImageContentDirectiveModule,
		MatDialogModule,
		DialogLayoutModule,
		CommonValidationRendererModule,
		RouterModule,
		...MATERIAL_MODULES,
	],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
	providers: PROVIDERS,
})
export class DepositLimitCalculatorModule {
	constructor(private componentFactoryResolver: ComponentFactoryResolver) {}

	getComponent() {
		return this.componentFactoryResolver.resolveComponentFactory(DepositLimitCalculatorContainer);
	}
}
